import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // global app-shell styles + design tokens
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider, applyTheme } from './context/ThemeContext';
import { initNative } from './capacitor-native';

// Paint the saved theme onto <html> BEFORE React mounts, so someone who chose
// dark never sees a light flash while the bundle boots. The provider takes over
// from here and keeps it in sync.
//
// The default is LIGHT, and the phone's own Light/Dark setting is only consulted
// when the user has explicitly picked "System" in Settings — mirroring
// DEFAULT_PREFERENCE in ThemeContext. Keep the two in step.
(function primeTheme() {
  try {
    const saved = localStorage.getItem('nomad.theme');
    const dark =
      saved === 'dark' ||
      (saved === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    applyTheme(dark ? 'dark' : 'light');
  } catch (_) {
    applyTheme('light');
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeProvider>
);

// Initialize native shell behaviors (no-op on the web).
initNative();
